// src/pages/Contact.js
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Decimal from 'decimal.js';

const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage }) => {
  const [selectedDates, setSelectedDates] = useState(null);
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const [formData, setFormData] = useState({
    name: null,
    email: null,
    entityName: null,
    mobile: null,
    password: null,
    parentId: null,
    balance: null,
    balanceCap: null,
    regDate: null,
    panNumber: null,
    nameOnAadhaar: null,
    nameOnPan: null,
    aadharNumber: null,
    aadharMask: null,
    status: null,
    approval: null,
    userType: null,
    uniqueId: null,
    gstNo: null,
    tanNumber: null,
    address: null,
    portId: null,
    otp: null,
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: { id: value } });

  };

  //*********************************** Fetch invoice data when the modal opens ********************************************************
  const token = authServices.getToken();
  useEffect(() => {

    const fetchInvoiceData = async () => {
      if (edit && invoiceId) {
        loader('enable');

        try {
          const response = await apiClient.get(`/api/admin/users/${invoiceId}`, {

            headers: {
              'access_token': token,
            },

          });
          if (response.data.Status === "SUCCESS") {

            setFormData({
              id: invoiceId || null,
              name: response.data.data.name || null,
              email: response.data.data.email || null,
              entityName: response.data.data.entityName || null,
              mobile: response.data.data.mobile || null,
              password: response.data.data.password || null,
              parentId: response?.data?.data?.parentId?.id || null,
              balance: response.data.data.balance || null,
              balanceCap: response.data.data.balanceCap || null,
              regDate: response.data.data.regDate || null,
              panNumber: response.data.data.panNumber || null,
              nameOnAadhaar: response.data.data.nameOnAadhaar || null,
              nameOnPan: response.data.data.nameOnPan || null,
              aadharNumber: response.data.data.aadharNumber || null,
              aadharMask: response.data.data.aadharMask || null,
              status: response.data.data.status || null,
              approval: response.data.data.approval || null,
              userType: response.data.data.userType || 'operator',
              uniqueId: response.data.data.uniqueId || null,
              gstNo: response.data.data.gstNo || null,
              tanNumber: response.data.data.tanNumber || null,
              address: response.data.data.address || null,
              portId: response?.data?.data?.portId?.id || null,

              otp: response.data.data.otp || null,
            });
          }
          else {
            console.log(response.data.message)
          }
        } catch (error) {
          console.error('catch Error :- ', error.response ? error.response.data.message : error);
        } finally {
          loader('disable');
        }
      }
    };

    fetchInvoiceData();
  }, [invoiceId, edit]);


  //******************************************* Handle save and update the data **************************************************
  const Alldata = {
    id: formData.id || invoiceId,
    parentId: {
      id: formData.parentId
      // id: 133

    },
    portId: {
      id: formData.portId
    },

    name: formData.name,
    email: formData.email,
    entityName: formData.entityName,
    mobile: formData.mobile,
    password: formData.password,
    // balance: parseInt(formData.balance) || 0.00,
    // balanceCap: parseInt(formData.balanceCap) || 0.00,

    balance: new Decimal(formData.balance ? formData.balance : 0.00).toFixed(2) || 0.00,
    balanceCap: new Decimal(formData.balanceCap ? formData.balanceCap : 0.00).toFixed(2) || 0.00,

    regDate: formData.regDate,
    panNumber: formData.panNumber ? formData.panNumber.toUpperCase() : '',
    nameOnAadhaar: formData.nameOnAadhaar,
    nameOnPan: formData.nameOnPan,
    aadharNumber: formData.aadharNumber,
    aadharMask: formData.aadharMask || null,
    status: formData.status || null,
    approval: formData.approval || null,
    userType: formData.userType,
    uniqueId: formData.uniqueId,
    gstNo: formData.gstNo,
    tanNumber: formData.tanNumber,
    address: formData.address,
    otp: formData.otp,
  };


  const handleSave = async () => {
    loader('enable');

    try {
      const response = await apiClient.put(`/api/admin/users/update`, Alldata, {

        headers: {
          'access_token': token,
        },

      });
      if (response.data.Status === "SUCCESS") {
        toggle_Edit();
        toast.success(response.data.message)
      }
      else {
        toast.error(response.data.message)
        console.log(response.data.message)
      }
    }
    catch (error) {
      toast.error(error.response.data.message)
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');
    }
  };

  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit Oprator
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="name" className="label-custom">Name</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div> */}
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="email" className="label-custom">Email</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div> */}
                  </div>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="entityName" className="label-custom">Entity Name</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="entityName"
                        name="entityName"
                        value={formData.entityName}
                        onChange={handleChange}
                      />
                    </div> */}

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="gstNo" className="label-custom">GST Number</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="gstNo"
                        name="gstNo"
                        value={formData.gstNo}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="balanceCap" className="label-custom">Balance Cap</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="balanceCap"
                        name="balanceCap"
                        value={formData.balanceCap === 0.00 ? 0.00 : formData.balanceCap}
                        onChange={handleChange}
                        onInput={(e) => {
                          // Allow digits and a single decimal point
                          e.target.value = e.target.value.replace(/[^0-9.]/g, ''); // Only allow digits and dots
                          // Prevent more than one decimal point
                          if ((e.target.value.match(/\./g) || []).length > 1) {
                            e.target.value = e.target.value.replace(/\.+$/, '');
                          }
                        }}
                      />
                    </div>

                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="mobile" className="label-custom">Mobile</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="mobile"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                      />
                    </div> */}
                  </div>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="password" className="label-custom">Password</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                      />
                    </div> */}

                    {/* 
                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="parentId" className="label-custom">ParentId</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="parentId"
                        name="parentId"
                        value={formData.parentId.id}
                        onChange={handleChange2}
                      />
                    </div> */}

                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="otp" className="label-custom">OTP</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="otp"
                        name="otp"
                        value={formData.otp}
                        onChange={handleChange}
                      />
                    </div> */}


                  </div>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="balance" className="label-custom">Balance</label>
                      <input
                        type="number"
                        className='input-custom'
                        id="balance"
                        name="balance"
                        value={formData.balance}
                        onChange={handleChange}
                      />
                    </div> */}

                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="tanNumber" className="label-custom">TAN Number</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="tanNumber"
                        name="tanNumber"
                        value={formData.tanNumber}
                        onChange={handleChange}
                          maxLength="10"
                      />
                    </div> */}


                  </div>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="regDate" className="label-custom">Reg Date</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="regDate"
                        name="regDate"
                        value={formData.regDate}
                        // onChange={}
                        disabled
                      />
                    </div> */}

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="panNumber" className="label-custom">Pan Number</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="panNumber"
                        name="panNumber"
                        value={formData.panNumber ? formData.panNumber.toUpperCase() : ''}
                        onChange={handleChange}
                        maxLength="10"
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="approval" className="label-custom">Approval</label>
                      <select
                        className="input-custom"
                        id="approval"
                        name="approval"
                        value={formData.approval}
                        onChange={handleChange}
                      >
                        <option value="approved">Approved</option>
                        <option value="pending">Pending</option>
                      </select>
                    </div>

                  </div>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="nameOnAadhaar" className="label-custom"> Aadhaar Name</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="nameOnAadhaar"
                        name="nameOnAadhaar"
                        value={formData.nameOnAadhaar}
                        onChange={handleChange}
                      />
                    </div> */}

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="nameOnPan" className="label-custom"> Pan Name</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="nameOnPan"
                        name="nameOnPan"
                        value={formData.nameOnPan}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="spacing w-50 d-inline-block">
                      <label htmlFor="tanNumber" className="label-custom">TAN Number</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="tanNumber"
                        name="tanNumber"
                        value={formData.tanNumber}
                        onChange={handleChange}
                      />
                    </div>

                  </div>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="aadharNumber" className="label-custom">Aadhaar Number</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="aadharNumber"
                        name="aadharNumber"
                        value={formData.aadharNumber}
                        onChange={handleChange}
                      />
                    </div> */}



                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="aadharMask" className="label-custom">Aadhaar Mask</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="aadharMask"
                        name="aadharMask"
                        value={formData.aadharMask}
                        onChange={handleChange}
                      />
                    </div> */}
                  </div>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="status" className="label-custom">Status</label>
                      <select
                        className='input-custom'
                        id="status"
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                      >
                        <option value="">Select Status</option>
                        <option value="Success">Success</option>
                        <option value="Pending">Pending</option>
                        <option value="Failed">Failed</option>
                      </select>
                    </div> */}

                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="approval" className="label-custom">Approval</label>

                      <select
                        className='input-custom'
                        id="approval"
                        name="approval"
                        value={formData.approval}
                        onChange={handleChange}
                      >
                        <option value="">Select Approval</option>
                        <option value="approved">Approve</option>
                        <option value="pending">Pending</option>
                      </select>
                    </div> */}
                  </div>

                  <div className='row w-100'>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="userType" className="label-custom">User Type</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="userType"
                        name="userType"
                        value={formData.userType}
                        onChange={handleChange}
                      />
                    </div> */}


                    <div className="spacing w-100 d-inline-block">
                      <label htmlFor="address" className="label-custom">Address</label>
                      <textarea
                        type="text"
                        className='input-custom'
                        id="address"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        rows="3"
                      />
                    </div>
                    {/* <div className="spacing w-50 d-inline-block">
                      <label htmlFor="uniqueId" className="label-custom">UniqueId</label>
                      <input
                        type="text"
                        className='input-custom'
                        id="uniqueId"
                        name="uniqueId"
                        value={formData.uniqueId}
                        onChange={handleChange}
                      />
                    </div> */}
                  </div>

                  {/* <div className="spacing w-50 d-inline-block">
                  <label htmlFor="portId" className="label-custom">PortId</label>
                  <input
                    type="text"
                    className='input-custom'
                    id="portId"
                    name="portId"
                    value={formData.portId.id}
                    onChange={handleChange2}
                  />
                </div> */}



                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div >
        </div >
      )}
    </>
  );
};

export default Edit;
